import React, {ReactElement} from 'react';
import { useSelector } from 'react-redux';

const PatientLoginError = (): ReactElement => {
  const error = useSelector((state: any) => state.auth)
  return (
    <div className="flex-centering">
      <h4>{error.errorReason?error.errorReason:"An error occurred while login please try again later"}</h4>
    </div>
  );
};

export default PatientLoginError;